module.exports = {
  // ================ TEXTS FOR SITE ELEMENTS ================
  p: {
    prgtitle: "SMART-TEAM-DEV-PORTAL [EN]",
    moredetailed: "More detailed...",
    loadingdata: "Loading data...",
    processing: "Processing...",
    send: "Send",
    changetheme: "Change color theme",
    usermenu: "User's menu",
    userpage: "User parameters",
    userexit: "<i class='fa fa-sign-out'></i>&nbsp;&nbsp;Exit",
    userlogin: "<i class='fa fa-sign-in'></i>&nbsp;&nbsp;Enter",
    gotoportal: "<i class='fa fa-share-square-o'></i>&nbsp;PORTAL",
    usrexit: "Exit",
    usrlogin: "Enter",
    fieldlogin: "User login",
    fieldpass: "Password",
    authFormTitle: "User authorization form",
    buttonlogin: "Sign in",
    redirection: "Redirection...",
    changelng: "Change language",
    noscript: "TO WORK THE SITE, YOU MUST ALLOW THE SCRIPTS EXECUTION",
    error: "Error",
    serverLogsTitle: "System logs"
  },
  ymaps: {
    pageTitle: "= Yandex-Maps =",
    theRouteBuilt: "The route is built",
    cantBuiltTheRoute: "I can't build a route. QueryString is not correct, it should be: ?from=...&to=....&through=",
    mileage: "Length, km = ",
    time: "Travel time, hour = ",
    ymapsModuleWasLoaded: "The Yandex-Maps module is loaded",
    yandexMapsIsNotLoaded: "The Yandex-Maps module was not loaded. Perhaps it is switched off by Administrator",
    couldNotBuildAroute: "Could not build a route",
    pageNotFound: "Page %ymapsLink% is not available",
    minimumAddressesRequired: "The addresses number in the 'addresses' array should be at least 2"
  },
  e: {
    missingADhash: "Srvbg-server rejected your authorization. You must be in the Internal network. Did you forget turn on the VPN?",
    nullLoginOrPass: "Required arguments are missing - login & pass",
    incorrectOldPassword: "Incorrect old password",
    userLoggedFailed: "Authorisation Error",
    incorrectAuthCode: "Invalid authorization code",
    lifetimeAuthCode: "The authorization code has expired",
    candFindOnlineComputer: "Can't find the user's computer with 'online' status",
    errorPageTitle: "Server-side error during page rendering attempt",
    fileNotFound: "File not found",
    fileconversionerror: "File Conversion Error",
    pserror: "PowerShell script execution error",
    userIsNotFound: "User is not found",
    userIsNotInInternalNetwork: "The user is not on the company's internal network",
    userIsNotInAllowedGroupsForSiteLogin: "User is not included in the allowed group for site authorization",
    thisSiteAllowOnlyADauthentication: "This site only allows user authentication from Active Directory!",
    userDoesntHavePhoneAuthType: "User has disabled phone code authorization",
    userDoesntHaveMessengersIDs: "The user (in settings or in ActiveDirectory) does not have any messenger ID specified (viberid, whatsappid, telegramid)",
    cantsendmessage: "Cannot send a message",
    incorrentfields: "Some fields are filled incorrectly",
    qrcodenouri: "No QR-code encoding URI passed",
    banned: "You are banned!",
    incorrectHostName1: "Incorrect hostname",
    incorrectHostName2: "Perhaps this is a mistake of the DNS server. Perform the 'ipconfig /flushdns' command, clean the browser cache (Ctrl + Shift + Del), restart the browser",
    userDisabled: "User is disabled",
    chartnodata: "No data was transmitted for plotting the chart",
    adTestError: "Error connecting to ActiveDirectory",
    adUserCantChangePwdThisWay: "An ActiveDirectory user cannot change the password this way. Press Ctrl+Alt+Del and select 'Change password'",
    unknownError: "Unknown error",
    somethingWrong: "Something went wrong",
    recIsNotFoundInDB: "Recordset is not found in the database",
    emptyDatabaseResult: "Request to the database returned an empty array",
    cryptoError2: "It was not possible to decipher the data from the Client. Incorrect key, data or iv!"
  },
  w: {
    userLoggedError1: "It was ",
    userLoggedError2: " attempt for last hour. If you send irregular accounting data 5 times, you will be blocked!",
    apiOnlyForLAN: "API functions are only allowed for Local network Users or for Trusted external IP addresses",
    attentionban: "You are not blocked yet. But if this happens, then only the site owner will be able to remove you from the blacklist.",
    nothingUpdated: "Nothing updated",
    onlyOneTimeCanCallSSOauthorization: "Only one time user can call the SSO authorization",
    resetAppSettingsNothing: "Application 'appname' was missing settings in database (factory settings already loaded)",
    thisLoginAlreadyExistInAD: "This user login already exists! Enter a new value",
    notYetDeveloped: "Not yet developed..."
  },
  i: {
    userLoggedSuccess: "You have successfully authorized",
    messagesent: "The message has been sent",
    finish: "Done",
    updatedFields: "Updated fields: ",
    newADuserHasBeenCreated: "A new ActiveDirectory User has been created success!",
    userIsInInternalNetwork: "The user is on the company's internal network",
    adTestSuccess: "Connection to ActiveDirectory was successful",
    settingsHasBeenSaved: "The settings have been saved",
    generalSettingsHasBeenSaved: "The settings have been saved. ",
    programWillRestart: "The program will be restarted on the server side",
    passwordWasChangedSuccess: "Password changed successfully",
    successDeleted: "Deleted successfully",
    successUpdated: "Updated successfully",
    successCreated: "Created successfully", // not used
    successOperation: "Completed successfully", // not used
    nothingHasChanged: "Nothing has changed"
  },
  unit: {
    pcs: "pcs",
    m: "m",
    m2: "m²",
    m3: "m³",
    mm: "mm",
    kg: "kg"
  },
  // ================ IMAGES ================
  img: {
    programmerisworking: { title: "The programmer is working on this site section.", src: "/img/general/programmer-is-working.png" }
  },
  ag: {
    successDeleted: "Deleted successfully",
    successUpdated: "Updated successfully",
    successCreated: "Created successfully",
    successOperation: "Completed successfully"
  },
  gpt: {
    chatGPTdisabled: "ChatGPT is disabled by the Administrator in the program settings",
    chatGPTtoken: "You must set API-key in the config",
    chatGPTproxy: "You must set Proxy-server to get access to api.openai.com in the config",
    userDoesntHaveEnoughRightsToWorkWithGPT: "You do not have sufficient rights to analyze this table using ChatGPT",
    userDoesntHaveEnoughRightsToRunVoiceCommands: "You do not have sufficient rights to run voice commands",
    thereAreNoDataForAnalysis: "No data for analysis",
    incorrectRequest: "Incorrect request",
    incorrectDatePeriod: "Incorrect dates period for building a request",
    speechRecognitionError: "Speech recognition error",
    speechRecognitionNull: "There is no recorded message. There is nothing to recognize",
    undefinedEmployee: "It was not possible to determine which employees are in question",
    undefinedCommand: "The command is not included in the list of permitted actions. Check out the list of permissible commands before calling a voice assistant",
    noAnswerFromChatGPT: "There is no answer from ChatGPT",
    ansWasCopiedToBuffer: "AI answer is copied to the clipboard",
    copyToBufferError: "There was an error when copying to the clipboard",
    voiceRecordingStart: "There is a record of the voice from the microphone",
    voiceRecordingStop: "The record of the voice is stopped",
    micPermissionsError: "There are no rights to access to the microphone of your device",
    tooltip1: "The data analysis of this table using ChatGPT",
    tooltip2: "Run a voice command"
  },
  viber: {
    viberBotOnSubscribe: `Hello! I'm Viber-Bot. You will be able to receive messages from me in Viber on current tasks and other alerts. 
      But first I need to identify you. Send your phone number like this: +79100000000`,
    viberBotNeedSubscribe: "At first I need to identify you. Send your phone number like this: +79100000000",
    viberBotUnderstandOnlyTextMessages: "Sorry. I understand only text messages",
    viberBotDummyAnswer: "There is no need to write comments in this chat. No one will see them anyway. The chat only works one way Bot -> Viber",
    viberBotIsAlreadyKnownYou: "You are already registered in Viber-Bot",
    userWithThisPhoneNotFound: "User with this phone is not found in database 'users'",
    viberBotHello1: "Hello, ",
    viberBotHello2: "! Your ID: ",
    viberBotHello3: ". You are successfully connected to this chat and will now receive messages from Viber-Bot",
    userHasAlreadyAnotherId: "The user with this phone number has a different Viber-ID. Only Administrator has the right to change Viber-ID for existing users",
    viberBotDisabledByAdmin: "ViberBot has been disabled by the Administrator"
  },
  telegram: {
    telegramBotOnSubscribe: `Hello! I'm Telegram-Bot. You will be able to receive messages from me in Viber on current tasks and other alerts. 
    But first I need to identify you. Send your phone number like this: +79100000000`,
    telegramBotNeedSubscribe: "At first I need to identify you. Send your phone number like this: +79100000000",
    telegramBotUnderstandOnlyTextMessages: "Sorry. I understand only text messages",
    telegramBotDummyAnswer: "There is no need to write comments in this chat. No one will see them anyway. The chat only works one way Bot -> Telegram",
    telegramBotIsAlreadyKnownYou: "You are already registered in Telegram-Bot",
    userWithThisPhoneNotFound: "User with this phone is not found in database 'users'",
    telegramBotHello1: "Hello, ",
    telegramBotHello2: "! Your ID: ",
    telegramBotHello3: ". You are successfully connected to this chat and will now receive messages from Telegram-Bot",
    userHasAlreadyAnotherId: "The user with this phone number has a different Telegram-ID. Only Administrator has the right to change Telegram-ID for existing users",
    telegramBotDisabledByAdmin: "TelegramBot disabled by Administrator",
    telegramBotUserIsNotAuthorizedToRunCommands: "The user is not authorized to execute commands",
    telegramBotUserDoesntHavePermission: "The user doesn't have enough permissions to execute this command",
    botMessageSelectACommandInMainMenu: "Select a command to start working with Telegram-Bot",
    thereAreNoAwailCommandsForYou: "Your user's rights don't allow commands in Telegram-Bot",
    helloUserIamChatGPTansYouQuestion: "*Greetings, %username%. You have selected the 'Artificial Intelligence mode'. Ask your question*",
    theMainComands: "To call the Main menu, type '*menu*' or '*/menu*'.\nTo start a dialogue with ChatGPT, type '*Hello*'.\n"
    + "To transfer files or photos to the server - type '*files*' or '*/files*'. You can choose a 'site folder' where the files will be saved.\n"
    + "If you want to interrupt the process, being in the filling the travel sheets or in any other mode, type '*cancel*' or '*/cancel*'.\n"
    + "To start a new process (to call any available command) - type '*menu*'.",
    wayBills: {
      startMessage1: "*= The mode of creating travel sheets and calculating trips =\nChoose the action*",
      startMessage2: "*= The mode of creating travel sheets and calculating trips =\nYou have an incomplete trip:*\n",
      startActions: [
        {text: "🛣️ Count the mileage and fuel", callback_data: "calcFuel"},
        {text: "🚗 Create a new trip", callback_data: "createNewTrip"},
        {text: "🏁 Complete the previous trip", callback_data: "finishLastTrip"},
        {text: "🛑 Return to the main menu", callback_data: "menu"}
      ],
      selectedStartAction1: "_The calculation mode of the kilometer, time and the right amount of fuel (without creating a waybill)_",
      selectedStartAction2: "_The beginning of the creation a travel sheet (arrival time can be supplemented upon arrival at the point 'B')_",
      selectedStartAction3: "_Completion of data entry into an unfinished travel sheet_",
      selectAvto: "Choose a car",
      selectedAvto: "Car: _%selCar%_",
      selectFuelType: "Select the fuel type",
      selectedFuelType: "Fuel: _%selFuel%_",
      selectConditions: "Select operating conditions",
      selectedConditions: "Conditions: _%selCondition%_",
      startAddress: "Enter the address of the departure",
      startAddressValue: "Departure address: _%startAddress%_",
      endAddress: "Enter your appointment address",
      endAddressValue: "Appointment address: _%endAddress%_",
      doYouWantToSetMiddleAddress: "Want to indicate the intermediate point address of the route - 'through'?",
      typeTheAddresses: "Enter *ROUTE ADDRESS POINTS*:",
      middleAddress: "Enter the intermediate point address",
      middleAddressValue: "The intermediate point address: _%middleAddress%_",
      startDateTime: "Enter the date and time of departure in the format 'DD.MM.YYYY Hour:Min'",
      endDateTime: "Enter the date and time of arrival in the format 'DD.MM.YYYY Hour:Min'",
      endDateTimeLater: "I'll fill it later, when I come",
      curTime: "The current time",
      startDateTimeValue: "Departure Date and time: _%startDateTime%_",
      endDateTimeValue: "Arrival Date and time: _%endDateTime%_",
      odometerNum: "Enter the odometer on arrival at the target address",
      odometerValue: "Odomometer value upon arrival - _%odometerValue%_",
      tripIsCalculated: "🎯 The route is calculated:\n*Kilometers = %mileage% km;\nCalculated time = %duration% hrs;\nThe estimated amount of fuel = %fuel% l.",
      downloadWayBill: "📑 *The travel sheet is saved to the Portal database*. You can download the travel sheet by link:",
      yamapsBuilding: "I'm opening the Yandex-Maps, build the route. Wait for 30 seconds please...",
      doYouWantToContinueFillWayBill: "Will we continue to fill out the Travel sheet?",
      goodBye: "Happy to help! Goodbye.\n\n_To return to the main menu - type the 'menu'_",
      createAnewTravelSheetNow: "You filled out all the necessary data.\n*Create a Travel sheet on the portal now?*",
      editTravelSheetNow: "You filled out all the necessary data.\n*Make changes to the existing Travel sheet on the portal?*",
      thereIsExistSimilarWaybill: "*The database already has a similar travel sheet. I will not create a duplicate!*"
    },
    botReturnToMainMenu: "🛑 Return to the main menu",
    unknownCommand: "🚫 Unknown command",
    notDevelopedYet: "🅾️ Not yet finalized...",
    youMustSelectInlineMenuItem: "⚠️ You must choose a value from the list",
    // Program TelegramBot
    mainButtons: [
      {
        key: "generalFunctions1", title: ["🚙 Our cars", "🛣️ Trips"], cfgCompany: "smartteamdev"
      },
      {
        key: "generalFunctions2", title: ["🧾 Cashier's checks", "💵 Salary"], cfgCompany: "smartteamdev", safe: "hidden"
      },
      {
        key: "generalFunctions3", cfgCompany: "smartteamdev",
        title: ["🤖 ChatGPT", "🖥 Files - to the server", "☢️ Tasks"]},
      {
        key: "accounting", cfgCompany: "smartteamdev", visForGroups: [
          "GC-ADMINS", "GC-HEADSHIP", "GC-SECRETARY", "GC-ACCHEADER", "GC-LAB-NDT-HEADER", "GC-LAB-MEX-HEADER", "GC-LAB-STROY-HEADER", "GC-LAB-EL-HEADER",
          "ATL-HEADSHIP", "ATL-ACCHEADER", "ATL-SECRETARY"
        ],
        title: ["📄 Bill to payment", "💰 The payments received", "🛂 SKUD"], safe: "hidden"
      },
      {
        key: "cancel", title: ["🛑 Cancel", "📒 Help"]
      }
    ],
    waitMessages: [
      "🤖 I need to think...",
      "🤖 Thinking...",
      "🤖 Computation...",
      "🤖 I'll figure out what to do...",
      "🤖 A second...",
      "🤖 I analyze the data...",
      "🤖 I work on it...",
      "🤖 Now I will do it...",
      "🤖 Twisting the screws...",
      "🤖 I just call to my mother and I will answer for your question...",
      "🤖 Didn't you study at school? So, I will do it...",
      "🤖 I just wake up now and do it...",
      "🤖 I need to call Houston to consult...",
      "🤖 Pentagon's brother will help us now...",
      "🤖 I'll go to consult with DeepSeek..."
    ]
  },
  mattermost: {
    mattermostBotNeedSubscribe: "At first I need to identify you. Send your phone number like this: +79100000000",
    mattermostBotIsAlreadyKnownYou: "You are already registered in Mattermost-Bot",
    mattermostBotHello1: "Hello, ",
    mattermostBotHello2: "! Your ID: ",
    mattermostBotHello3: ". You are successfully connected to this chat and will now receive messages from Mattermost-Bot",
    userHasAlreadyAnotherId: "The user with this phone number has a different Mattermost-ID. Only Administrator has the right to change Mattermost-ID for existing users",
    mattermostBotDisabledByUser: "MattermostBot has been disabled by the user",
    mattermostBotDisabledByAdmin: "MattermostBot disabled by Administrator",
    mbotCommandError: "Command processing error",
    mbotUnknownCommand: "Unknown command",
    mbotDummyAnswer: "The logical part of the bot cannot process user messages yet",
    mattermostBotUserIsNotAuthorizedToRunCommands: "The user is not authorized to execute commands",
    mattermostBotUserDoesntHavePermission: "The user doesn't have enough permissions to execute this command",
    botMessageSelectACommandInMainMenu: "Select a command to start working with Mattermost-Bot",
    thereAreNoAwailCommandsForYou: "Your user's rights don't allow commands in Mattermost-Bot",
    helloUserIamChatGPTansYouQuestion: "*Greetings, %username%. You have selected the 'Artificial Intelligence mode'. Ask your question*",
    theMainComands: "To call the Main menu, type '*menu*'.\nTo start a dialogue with ChatGPT, type '*Hello*'.\n"
    + "To transfer files or photos to the server - type '*files*'. You can choose a 'site folder' where the files will be saved.\n"
    + "If you want to interrupt the process, being in the filling the travel sheets or in any other mode, type '*cancel*'.\n"
    + "To start a new process (to call any available command) - type '*menu*'.\n"
    + "On the right of the text area field in the Mattermost, a button appears, when you click the button - the Main menu will be hidden or shown (so that it does not interfere)",
    wayBills: {
      startMessage1: "*= The mode of creating travel sheets and calculating trips =\nChoose the action*",
      startMessage2: "*= The mode of creating travel sheets and calculating trips =\nYou have an incomplete trip:*\n",
      startActions: [
        {text: "🛣️ Count the mileage and fuel", callback_data: "calcFuel"},
        {text: "🚗 Create a new trip", callback_data: "createNewTrip"},
        {text: "🏁 Complete the previous trip", callback_data: "finishLastTrip"},
        {text: "🛑 Cancel", callback_data: "cancel"}
      ],
      selectedStartAction1: "*The calculation mode of the kilometer, time and the right amount of fuel (without creating a waybill)*",
      selectedStartAction2: "*The beginning of the creation a travel sheet (arrival time can be supplemented upon arrival at the point 'B')*",
      selectedStartAction3: "*Completion of data entry into an unfinished travel sheet*",
      modalDlgTitle1: "Select parameters",
      submitButtonConfirmSelection: "Confirm selection",
      submitButtonOK: "OK",
      selectAvto: "Choose a car",
      selectedAvto: "Car: *%selCar%*",
      selectFuelType: "Select the fuel type",
      selectedFuelType: "Fuel: *%selFuel%*",
      selectConditions: "Select operating conditions",
      selectedConditions: "Conditions: *%selCondition%*",
      selectedAvtoFuelConditions: "Car: *%selCar%*; Fuel: *%selFuel%*; Conditions: *%selCondition%*",
      startAddress: "**Enter the address of the departure**",
      startAddressValue: "Departure address: *%startAddress%*",
      endAddress: "**Enter your appointment address**",
      endAddressValue: "Appointment address: *%endAddress%*",
      doYouWantToSetMiddleAddress: "Want to indicate the intermediate point address of the route - 'through'?",
      middleAddress: "**Enter the intermediate point address**",
      middleAddressValue: "The intermediate point address: *%middleAddress%*",
      startDateTime: "**Enter the date and time of departure in the format 'DD.MM.YYYY Hour:Min'**",
      endDateTime: "**Enter the date and time of arrival in the format 'DD.MM.YYYY Hour:Min'**",
      endDateTimeLater: "I'll fill it later, when I come",
      curTime: "The current time",
      startDateTimeValue: "Departure Date and time: *%startDateTime%*",
      endDateTimeValue: "Arrival Date and time: *%endDateTime%*",
      odometerNum: "Enter the odometer on arrival at the target address",
      odometerValue: "Odomometer value upon arrival - *%odometerValue%*",
      tripIsCalculated: "🎯 The route is calculated:\n*Kilometers = %mileage% km;\nCalculated time = %duration% hrs;\nThe estimated amount of fuel = %fuel% l.",
      downloadWayBill: "📑 *The travel sheet is saved to the Portal database*. You can download the travel sheet by [link](%wayBillLink%)",
      yamapsBuilding: "I'm opening the Yandex-Maps, build the route. Wait for 30 seconds please...",
      doYouWantToContinueFillWayBill: "Will we continue to fill out the Travel sheet?",
      goodBye: "Happy to help! Goodbye.\n\n*To return to the main menu - type the 'menu'*",
      createAnewTravelSheetNow: "You filled out all the necessary data.\n*Create a Travel sheet on the portal now?*",
      editTravelSheetNow: "You filled out all the necessary data.\n*Make changes to the existing Travel sheet on the portal?*",
      thereIsExistSimilarWaybill: "*The database already has a similar travel sheet. I will not create a duplicate!*"
    },
    botMainMenu: "☰ Main Menu ☰",
    botReturnToMainMenu: "🛑 Return to the main menu",
    unknownCommand: "🚫 Unknown command",
    notDevelopedYet: "🅾️ Not yet finalized...",
    youMustSelectInlineMenuItem: "⚠️ You must choose a value from the list",
    youMustTypeSomeTextInTheFields: "⚠️ You must fill the fields with text in accordance with the fields semantic meaning",
    // Program MattermostBot
    mainButtons: [
      {
        key: "generalFunctions1", text: "Motor transport:", cfgCompany: "smartteamdev",
        actions: [{key: "avto", title: "🚙 Our cars"}, {key: "trips", title: "🛣️ Trips"}]
      },
      {
        key: "generalFunctions2", text: "My expenses and salary:", cfgCompany: "smartteamdev",
        actions: [{key: "cashierschecks", title: "🧾 Cashier's checks"}, {key: "salary", title: "💵 Salary", safe: "hidden"}]
      },
      {
        key: "generalFunctions3", text: "AI, Files, Tasks:", cfgCompany: "smartteamdev",
        actions: [{key: "chatgpt", title: "🤖 ChatGPT"}, {key: "files", title: "🖥 Files - to the server"}, {key: "tasks", title: "☢️ Tasks"}]
      },
      {
        key: "accounting", text: "Accounting", cfgCompany: "smartteamdev", safe: "hidden", visForGroups: [
          "GC-ADMINS", "GC-HEADSHIP", "GC-SECRETARY", "GC-ACCHEADER", "GC-LAB-NDT-HEADER", "GC-LAB-MEX-HEADER", "GC-LAB-STROY-HEADER", "GC-LAB-EL-HEADER",
          "ATL-HEADSHIP", "ATL-ACCHEADER", "ATL-SECRETARY"
        ],
        actions: [{key: "bill", title: "📄 Bill to payment"}, {key: "payments", title: "💰 The payments received"}, {key: "skud", title: "🛂 SKUD"}]
      },
      {
        key: "cancel", text: "",
        actions: [{key: "cancel", title: "🛑 Cancel"}, {key: "help", title: "📒 Help"}]
      }
    ],
    waitMessages: [
      "🤖 I need to think...",
      "🤖 Thinking...",
      "🤖 Computation...",
      "🤖 I'll figure out what to do...",
      "🤖 A second...",
      "🤖 I analyze the data...",
      "🤖 I work on it...",
      "🤖 Now I will do it...",
      "🤖 Twisting the screws...",
      "🤖 I just call to my mother and I will answer for your question...",
      "🤖 Didn't you study at school? So, I will do it...",
      "🤖 I just wake up now and do it...",
      "🤖 I need to call Houston to consult...",
      "🤖 Pentagon's brother will help us now...",
      "🤖 I'll go to consult with DeepSeek..."
    ]
  },
  chatGPT: {
    thinking: "✍🏼 Think...",
    botGeneratingAnswer: "The bot generates a response..."
  },
  api1c: {
    c1disabled: "API 1C module is disabled by the Administrator",
    c1LinkIsNull: "Missing the 'API 1C URI' in the program settings",
    c1AuthIsNull: "Missing the 'API 1C Accounting data' in the program settings",
    accessDenied: "Access to the 'API 1C (oData)' is prohibited. Incorrect accounting data",
    cantFind1Cserver: "Could not find a 1C-server suitable for this function in the program settings",
    dbNameNotSpecified: "Database name not specified",
    companyNotSpecified: "Company name not specified",
    cantGetAnyRecordsets: "Could not get any records from 1C",
    unknownError: "An unknown error occurred while accessing the API 1C (oData)"
  },

  /// ===========  site =========== ///

  navbar: {
    logoText: "SmartTeamDev",
    home: "Home",
    portal: "Portal",
    services: "Services",
    media: "Media",
    contact: "Contact",
    requestDemo: "Demo version",
    languageLabel: "Language",
    langRu: "Russian",
    langEn: "English",
    langTr: "Turkish",
    menuAriaLabel: "SmartTeamDev navigation",
    hamburgerAriaLabel: "Open menu"
  },
  footer: {
    logoText: "SmartTeamDev",
    description: "Corporate portal and digital services for teams.",
    productsTitle: "Sections",
    productPortal: "Portal",
    productServices: "Services",
    productProjects: "Projects",
    productMedia: "Media",
    companyTitle: "Company",
    companyContact: "Contact",
    companyPrivacy: "Privacy",
    companyDocs: "Docs",
    companySupport: "Support",
    contactsTitle: "Contacts",
    phone: "+7 (495) 123-45-67",
    email: "demo@smartteamdev.ru",
    address: "Moscow, demo office",
    copyright: "© 2026 SmartTeamDev",
    scrollTopAriaLabel: "Back to top"
  },
  common: {
    title: "SmartTeamDev",
    description: "SmartTeamDev demo website",
    loading: "Loading",
    error: "Error",
    close: "Close"
  }
};
